import React from 'react';
import Icon from '@ant-design/icons';
import HomeIconSVG from './HomeIcon';
import AppointmentIconIconSVG from './AppointmentIconIcon';
import ChannelsIconSVG from './ChannelsIcon';
import ExternalLinkIconSVG from './ExternalLinkIcon';
import PracticeFrontIconSVG from './PracticeFrontIcon';
import ProspectsIconSVG from './ProspectsIcon';
import AccessProfileSVG from './AccessProfileIcon';
import AccessClipboardCheckSVG from './AccessClipboardCheckIcon';
import AccessKeySVG from './AccessKeyIcon';
import LogoutSVG from './LogoutIcon';
import ConfigSVG from './ConfigIcon';
import MenuHealthSVG from './MenuHealth';
import MenuKiwiSVG from './MenuKiwi';
import MenuHelloSVG from './MenuHello';
import ReputationManagementSVG from './ReputationManagementIcon';
import MenuHelloKlaritySVG from './MenuHelloKlarity';
import MenuContractLinkSVG from './MenuContractLink';
import MenuMessageSVG from './MenuMessage';
import ProviderSearchIconSVG from './ProviderSearchIcon';
import KlarityReviewsSVG from './KlarityReviewsIcon';
import EhrIconSVG from './EhrIcon';
import CalendarSVG from './CalendarIcon';
import InboxSVG from './InboxIcon';
import FileTextOutlinedSVG from './FileTextOutlined';
import ProfileSVG from './ProfileIcon';
import PlusIconSVG from './PlusIcon';
import TextVisitIconSVG from './TextVisitIcon';
import EmptyChatIconSVG from './EmptyChatIcon';
import PrescriptionsIconSVG from './PrescriptionsIcon';
import FinancialsIconSVG from './FinancialsIcon';
import AdjustLengthIconSVG from './AdjustLengthIcon';
import TellAvaIconSVG from './TellAvaIcon';
import ChangeToneIconSVG from './ChangeToneIcon';
import WriteLikeIconSVG from './WriteLikeIcon';
import EFaxIconSVG from './EFaxIcon';
import PracticeOverviewIconSVG from './PracticeOverviewIcon';
import CredentialingIconSVG from './CredentialingIcon';
import InsuranceBillingIconSVG from './InsuranceBillingIcon';

export const HomeIcon = <Icon component={HomeIconSVG} />;
export const EhrIcon = <Icon component={EhrIconSVG} />;
export const AppointmentIconIcon = <Icon component={AppointmentIconIconSVG} />;
export const ChannelsIcon = <Icon component={ChannelsIconSVG} />;
export const ExternalLinkIcon = <Icon component={ExternalLinkIconSVG} />;
export const PracticeFrontIcon = <Icon component={PracticeFrontIconSVG} />;
export const ProspectsIcon = <Icon component={ProspectsIconSVG} />;
export const AccessProfileIcon = <Icon component={AccessProfileSVG} />;
export const ProviderSearchIcon = <Icon component={ProviderSearchIconSVG} />;
export const AccessClipboardCheckIcon = <Icon component={AccessClipboardCheckSVG} />;
export const AccessKeyIcon = <Icon component={AccessKeySVG} />;
export const LogoutIcon = <Icon component={LogoutSVG} />;
export const ConfigIcon = <Icon component={ConfigSVG} />;
export const MenuHealthIcon = <Icon component={MenuHealthSVG} />;
export const MenuKiwiIcon = <Icon component={MenuKiwiSVG} />;
export const MenuHelloIcon = <Icon component={MenuHelloSVG} />;
export const ReputationManagementIcon = <Icon component={ReputationManagementSVG} />;
export const MenuHelloKlarityIcon = <Icon component={MenuHelloKlaritySVG} />;
export const MenuContractLinkIcon = <Icon component={MenuContractLinkSVG} />;
export const KlarityReviewsIcon = <Icon component={KlarityReviewsSVG} />;
export const CalendarIcon = <Icon component={CalendarSVG} />;
export const InboxIcon = <Icon component={InboxSVG} />;
export const FileTextOutlined = <Icon component={FileTextOutlinedSVG} />;
export const ProfileIcon = <Icon component={ProfileSVG} />;
export const PlusIcon = <Icon component={PlusIconSVG} />;
export const TextVisitIcon = <Icon component={TextVisitIconSVG} />;
export const EmptyChatIcon = <Icon component={EmptyChatIconSVG} />;
export const PrescriptionsIcon = <Icon component={PrescriptionsIconSVG} />;
export const AdjustLengthIcon = <Icon component={AdjustLengthIconSVG} />;
export const TellAvaIcon = <Icon component={TellAvaIconSVG} />;
export const ChangeToneIcon = <Icon component={ChangeToneIconSVG} />;
export const FinancialsIcon = <Icon component={FinancialsIconSVG} />;
export const WriteLikeIcon = <Icon component={WriteLikeIconSVG} />;
export const MenuMessageIcon = <Icon component={MenuMessageSVG} />;
export const EFaxIcon = <Icon component={EFaxIconSVG} />;
export const PracticeOverviewIcon = <Icon component={PracticeOverviewIconSVG} />;
export const CredentialingIcon = <Icon component={CredentialingIconSVG} />;
export const InsuranceBillingIcon = <Icon component={InsuranceBillingIconSVG} />;
